import React, { Children, useState } from "react";
import { Link } from "react-router-dom";
import { Menu } from "antd";
import {
  CalendarOutlined,
  CodeSandboxOutlined,
  DownOutlined,
  ExperimentOutlined,
  PieChartOutlined,
  BarChartOutlined,
  FundOutlined,
  GlobalOutlined,
  AreaChartOutlined,
  CaretUpOutlined,
  CaretDownOutlined,
  ExportOutlined,
} from "@ant-design/icons";
import { isAuthenticated } from "@seims/shared/src/security";

export const MenuView = () => {
  const initialLandingPage = isAuthenticated() ? "my-programmes" : "home";

  const [current, setCurrent] = useState(initialLandingPage);
  const [collapsed, setCollapsed] = useState(false);
  const [activeMenu, setActiveMenu] = useState("");

  const onClick = (e) => {
    setCurrent(e.key);
  };

  const toggleCollapsed = (e) => {
    setActiveMenu([e]);
    setCollapsed(!collapsed);
  };

  const items = [
    !isAuthenticated() && {
      label: (
        <Link className="menu-link" to="/">
          Home
        </Link>
      ),
      key: "home",
    },

    isAuthenticated() && {
      label: (
        <Link className="menu-link logged-in-link" to="/my-dashboard">
          My Dashboard
        </Link>
      ),
      key: "my-programmes",
    },

    !isAuthenticated() && {
      label: (
        <Link
          className="menu-link"
          to="/nys/landing"
          data-testid="test-initiatives-menu"
        >
          <span>
            Initiatives <CaretDownOutlined />{" "}
          </span>
        </Link>
      ),
      key: "programmes",
      children: [
        {
          label: (
            <Link to="/nys/landing" data-testid="test-nys-submenu">
              National Youth Service
            </Link>
          ),
          key: "nys",
          icon: <CodeSandboxOutlined />,
        },
        {
          label: (
            <Link to="/public-events" data-testid="test-seims-events-submenu">
              SEIMS Events App
            </Link>
          ),
          key: "events",
          icon: <CalendarOutlined />,
        },
        // {
        //   label: (
        //     <Link to="/citisci" data-testid="test-citisci-submenu">
        //       Citizen Science
        //     </Link>
        //   ),
        //   key: "citisci",
        //   icon: <GlobalOutlined />,
        // },
        // {
        //   label: (
        //     <Link to="/volusci" data-testid="test-volusci-submenu">
        //       Volunteer Scientist
        //     </Link>
        //   ),
        //   key: "volusci",
        //   icon: <ExperimentOutlined />,
        // },
      ],
    },
    //! CODE COMMENTED OUT IN PREPARATION FOR THE NSW LAUNCH
    // {
    //   label: (
    //     <Link className="menu-link" to="/doc-repo/home">
    //       Document Repository
    //     </Link>
    //   ),
    //   key: "docrepo",
    // },
    // {
    //   label: (
    //     <Link className="menu-link">
    //       <span>Reports <CaretDownOutlined /></span>
    //     </Link>
    //   ),
    //   key: "reports",
    //   children: [
    //     {
    //       label: <Link to="/report-events">Events</Link>,
    //       key: "report-events",
    //       icon: <PieChartOutlined />,
    //       children: [
    //         {
    //           label: <Link to="/report-events-groups">Events Groups</Link>,
    //           key: "report-events-groups",
    //           icon: <ExportOutlined />,
    //         },
    //         {
    //           label: <Link to="/report-individual-events">Individual Events</Link>,
    //           key: "report-individual-events",
    //           icon: <ExportOutlined />,
    //         },
    //         {
    //           label: <Link to="/report-venue-type">Venue Types</Link>,
    //           key: "report-venue-type",
    //           icon: <ExportOutlined />,
    //         }
    //       ]
    //     },
    //     {
    //       label: <Link to="/report-nys">National Youth Service</Link>,
    //       key: "report-nys",
    //       icon: <BarChartOutlined />,
    //     },
    //     {
    //       label: <Link to="/report-partnership">Partnership</Link>,
    //       key: "report-partnership",
    //       icon: <FundOutlined />,
    //     },
    //     {
    //       label: <Link to="/report-stemi">STEMI Olympiad</Link>,
    //       key: "report-stemi",
    //       icon: <AreaChartOutlined />,
    //       children: [
    //         {
    //           label: <Link to="/report-stemi-overview">Overview</Link>,
    //           key: "report-stemi-overview",
    //           icon: <ExportOutlined />,
    //         },
    //         {
    //           label: <Link to="/report-stemi-sector">Sector</Link>,
    //           key: "report-stemi-sector",
    //           icon: <ExportOutlined />,
    //         },
    //         {
    //           label: <Link to="/report-stemi-competition">Competition/Sector</Link>,
    //           key: "report-stemi-competition",
    //           icon: <ExportOutlined />,
    //         }
    //       ]
    //     },
    //   ],
    // },
    {
      label: (
        <Link className="menu-link" to="/faq">
          FAQ
        </Link>
      ),
      key: "faq",
    },

    {
      label: (
        <Link className="menu-link" to="/user-guides">
          User Guides
        </Link>
      ),
      key: "user-guides",
    },
    //   isAuthenticated() && (
    //   {
    //     label: (
    //       <Link className="menu-link logged-in-link" to="/my-dashboard">
    //         My Dashboard
    //       </Link>
    //     ),
    //     key: "my-programmes",
    //   }
    // ),
  ];

  return (
    <div>
      <Menu
        mode="horizontal"
        style={{
          backgroundColor: "#1F6297",
          color: "white",
          border: "1px solid #707070",
          opacity: 1,
        }}
        onClick={onClick}
        selectedKeys={[current]}
        items={items}
        onOpenChange={toggleCollapsed}
        // expandIcon={<DownOutlined />}
      />
      {/* My programmes/initiatives space */}

      {/* {isAuthenticated() && (  
        <div className="logged-in-link">
          <Link className="menu-link" to="/portal/my-programmes">
          My Initiatives
        </Link>
        </div> 
      )
    } */}
    </div>
  );
};
